'use client';

import React from 'react';
import { ExperienceType } from '../types';
import Vehicles, { Vehicle } from '@/components/packages/Vehicles';

interface ExperienceVehiclesProps {
  experience: unknown;
  type: ExperienceType;
}

export const ExperienceVehicles: React.FC<ExperienceVehiclesProps> = ({
  experience,
  type,
}) => {
  if (!experience || type !== 'package') return null;

  const exp = experience as {
    vehicles?: Vehicle[];
  };

  if (!Array.isArray(exp?.vehicles) || exp.vehicles.length === 0) return null;

  return <Vehicles vehicles={exp.vehicles} />;
};
